/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-section[_ngcontent-%COMP%]{margin-top:20px}.basic.inverted.button[_ngcontent-%COMP%]{border:none!important;box-shadow:none!important}.header[_ngcontent-%COMP%]   .label[_ngcontent-%COMP%]{margin-left:25px}a[_ngcontent-%COMP%]{color:#83a1d4}a[_ngcontent-%COMP%]:hover{color:#729fec}.selectable[_ngcontent-%COMP%]{cursor:pointer}tr.selectable[_ngcontent-%COMP%]:hover{background:#636377}.ellipsis.icon[_ngcontent-%COMP%]{margin-top:4px;cursor:pointer}.pool-contributions[_ngcontent-%COMP%]{margin-top:30px;max-height:150px;overflow-y:auto}"];
export { styles as styles };
